var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-grid"},_vm._l((_vm.diseases),function(disease,index){return _c('button-component',{key:index,class:{
      active: _vm.diseasesData[index] === true,
      disable: _vm.disableDiseases[index] === true
    },attrs:{"index":index,"disable":_vm.disableDiseases[index],"methods":"toggleActive","buttonLabel":disease},on:{"toggleActive":_vm.toggleActive}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }